export const TEST_RUN_ENDPOINTS = {
    BASE: '/test-runs',
    LIST: '/test-runs',
    DETAIL: '/test-runs/:id',
    CREATE: '/test-runs',
    UPDATE: '/test-runs/:id',
    DELETE: '/test-runs/:id',
    START: '/test-runs/:id/start',
    COMPLETE: '/test-runs/:id/complete',
    ADD_ITEMS: '/test-runs/:id/items',
    REMOVE_ITEM: '/test-runs/:id/items/:test_run_item_id',
    ASSIGN_USER: '/test-runs/:id/assign',
    ASSIGN_USER_TO_ITEM: '/test-runs/items/:item_id/assign',
    UPDATE_ITEM_STATUS: '/test-runs/items/:item_id/status',
    UPDATE_ITEM_COMMENT: '/test-runs/items/:item_id/comment',
    CREATE_STEP: '/test-runs/items/:item_id/steps',
    UPDATE_STEP_STATUS: '/test-runs/steps/:step_id/status',
    UPDATE_CHECKLIST_ITEM_STATUS: '/test-runs/steps/:step_id/checklist/:item_index/status',
    UPDATE_CHECKLIST_ITEM_RESULT: '/test-runs/steps/:step_id/checklist/:item_index/result'
} as const; 
 